import { render, staticRenderFns } from "./IconTeammates.vue?vue&type=template&id=e7f94f38"
import script from "./IconTeammates.vue?vue&type=script&lang=js"
export * from "./IconTeammates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports